import "core-js/fn/object/assign";
import "~/setup/polyfills";
import viewDefinitions from "~/setup/view-definitions";
import serverInitializer from "~/setup/server-initializer";
import domInitializer from "~/setup/dom-initializer";

// Set global variables
const namespace = "GBK";

global[namespace] = global[namespace] || {};
global[namespace].views = viewDefinitions();

if (__SERVER__) {
    serverInitializer();
}

if (!__SERVER__) {
    // Polyfill for objectFitImages in IE9, IE10, IE11, Edge, Safari
    // https://github.com/bfred-it/object-fit-images
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const objectFitImages = require("object-fit-images");

    objectFitImages();

    // Polyfill for intersection observer (IE7+, Safari 6+)
    require("intersection-observer");

    require("whatwg-fetch");

    // Start DOM initializer
    domInitializer();
}
